import logo from "../components/project/brand/logo.png";
import noimage from "../components/project/brand/noimage.jpg";
import banner from "../components/project/brand/login-banner.jpeg";
import avathar from "../components/project/brand/avathar.jpg";
import mobLogo from "../components/project/brand/logo.png";
export { logo, noimage, banner, avathar, mobLogo };
